export default {
  'avatar.category': 'Unknown Category',
  'avatar.community': 'Unknown Community',
  'avatar.user': 'Unknown User',
} as const;
